import React from 'react';
import styled from "styled-components";

const Text = styled.span`
  color: ${props => {
    let color = props.theme.color.gray_400;
    const NumberedValue = Number(props.value);
    if (NumberedValue >= 4) color = props.theme.color.yellow_100;
    else if (NumberedValue >= 3) color = props.theme.color.blue_400;
    else if (NumberedValue >= 2) color = "#259A7E";
    return color;
  }};

  
  font-weight: ${props => {
    let weight = 'normal';
    if (props.fontWeight) weight = props.fontWeight;
    return weight;
  }};
  font-size: ${props => {
    let size = '14px';
    if (props.fontSize) size = props.fontSize;
    return size;
  }};
  line-height: ${props => {
    let size = '14px';
    if (props.lineHeight) size = props.lineHeight;
    return size;
  }};
`;

const KDAText = ({children, fontWeight, fontSize,lineHeight,value}) => {
    return (
        <Text fontWeight={fontWeight} fontSize={fontSize} lineHeight={lineHeight} value={value}>{children}</Text>
    );
};

export default KDAText;